import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, effect } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, PopoverController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { InputFieldComponent } from 'src/app/components/input-field/input-field.component';
import { AuthorisedRepresentative } from 'src/app/models/authorised-representative.model';
import { IncorporationForm } from 'src/app/models/incorp-from.model';
import { GeneralService } from 'src/app/services/general.service';
import { StateService } from 'src/app/services/state.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss'],
  imports: [IonicModule, CommonModule, FormsModule, InputFieldComponent],
  standalone: true
})
export class CompanyListComponent {

  tempCompanyList = []
  companyList = []
  companyDetails = {}
  showCompanyList = false
  currentUser = {}
  searchValue = ''

  constructor(
    protected popoverCtrl: PopoverController,
    protected stateService: StateService,
    private http: HttpClient,
    protected generalService: GeneralService
  ) {

    effect(() => {
      this.currentUser = this.stateService.userInfo
    })

    effect(() => {
      this.companyList = this.stateService.companyList
      this.tempCompanyList = this.companyList
    })

    effect(() => {
      this.companyDetails = this.stateService.companyDetails
    })
  }

  changeDefaultCompany(detail) {
    console.log(detail)

    if (detail['id'] !== this.companyDetails['id']) {
      this.http.post(`${baseUrl}/updateDefaultCompany`, { id: detail['id'] }).subscribe()
      this.stateService.setCompanyDetails({})
      this.stateService.setTaskList([])
      this.stateService.setResolutionList([])
      this.stateService.setResolutionList([])
      this.stateService.updateSelectedCompany(detail)
      this.generalService.navigateRoot(`home`)
    }

    this.popoverCtrl.dismiss()
  }

  generatePartnerLink() {
    let applicationId = Date.now()
    this.generalService.generalPartnerLink('cosec-partner/' + applicationId, applicationId)
  }

  async startNewBusiness(id?) {
    const confirmation = await this.generalService.showConfirmButton({
      title: 'Confirmation',
      description: 'Do you want to add a new business?'
    })

    if (confirmation !== 'Confirm') return

    this.popoverCtrl.dismiss()
    id = id || Date.now()

    let newCompany: IncorporationForm = {
      action: '',
      fyeOptions: '',
      custom_fye: '',
      id: id.toString(),
      partnerId: 0,
      country: '',
      business_structure: 'Company (Sdn Bhd)',
      current_step: 0,
      up_to_step: 1,
      plan_selected: null,
      isSoftonPartner: false,
      company_names: [
        '', '', ''
      ],
      business_codes: [
        '', '', ''
      ],
      company_description: '',
      have_business_address: '1',
      business_address: {
        address_country: '',
        line1: '',
        line2: '',
        postcode: '',
        city: '',
        state: ''
      },
      trademark_application: {
        logo: {},
        business_address: '',
        class: [],
        selected: false
      },
      domain_application: {},
      role: '',
      person_in_charges: [],
      paid_up_capital: '',
      promo_code: '',
      recommended_partner: {
        altomate: false,
        // namecheap: false,
        qne: false,
        // teeip: false
      },
      sub_total: 0,
      total: 0,
      tax: 0,
      authorised_representative: new AuthorisedRepresentative('ar'),
      is_new_form: true,
      price_per_share: '1',
      authorising_email: '',
      submit: false,
      tnc: false,
      hasNominee: null,
      newUI: true,
      company_name_questions: {
        single_letters: {
          selected: false,
          description: ''
        },
        not_in_bm_en: {
          selected: false,
          description: ''
        },
        non_director_name: {
          selected: false,
          description: '',
          file: {

          }
        },
        word_similar: {
          selected: false,
          description: '',
          file: {

          }
        },
        trademark_word: {
          selected: false,
          description: '',
          file: {

          }
        },
        controlled_word: {
          selected: false,
          description: '',
          file: {

          }
        }
      }
    }

    this.stateService.updateSelectedCompany(newCompany)
    this.stateService.setCompanyDetails(newCompany)
    this.stateService.addCompanyList({
      display_name: 'New Business',
      id: id,
      manager: true,
      submit: false,
    })

    await firstValueFrom(
      this.http.put(baseUrl + '/incorporate', newCompany)
    );

    this.generalService.navigateToPage('home')
  }

  filterCompanyList() {
    this.companyList = this.tempCompanyList.filter(g => {
      return (g['display_name'] || '').toLowerCase().includes(this.searchValue.toLowerCase())
    })
  }


}
